package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ko")
val KoStrings = Strings(
    analyzer = "분석기",
    appreciationOverview = "가치 상승 개요",
    chartLegendInterest = "이자",
    chartLegendPrincipal = "원금",
    chartXaxisMonths = "개월",
    chartYaxisPayment = "지불",
    code = "ko",
    costOfCredit = "신용 비용",
    creditDealAnalyzerDescription = "대출 세부 정보를 입력하여 신용 거래에 대한 포괄적인 분석을 받으십시오. 당사의 분석기는 주요 지표를 평가하여 대출의 실제 비용을 이해하고 정보에 입각한 결정을 내리는 데 도움을 줍니다.",
    detailsGoodRateLongTerm = "좋은 금리이지만 장기간으로 인해 총 비용이 높습니다.",
    detailsHighApr = "높은 APR. ",
    detailsHighInterestCost = "높은 총 이자 비용.",
    detailsHighRateShortTerm = "높은 금리이지만 단기간으로 인해 총 비용이 낮게 유지됩니다.",
    detailsLowApr = "낮은 APR. ",
    detailsLowInterestCost = "낮은 총 이자 비용.",
    discountsTradeIn = "할인 / 보상 판매",
    displayName = "한국어",
    distribution = "분배",
    downPayment = "계약금",
    effectiveApr = "APR",
    headerBalance = "잔액",
    headerDate = "날짜",
    headerInterest = "이자",
    headerMonth = "#",
    headerPayment = "지불",
    headerPrincipal = "원금",
    hideDetails = "세부 정보 숨기기",
    interest = "이자",
    invalidData = "유효하지 않은 데이터",
    loanAmountSupportingText = "추가 비용을 포함한 총 대출 금액.",
    loanDetails = "대출 세부 정보",
    paymentSupportingText = "예상 월 납입금.",
    paymentComposition = "지불 구성",
    percentSymbol = "%",
    principal = "원금",
    ratingBad = "나쁜 거래",
    ratingExcellent = "훌륭한 거래",
    ratingFair = "공정한 거래",
    ratingGood = "좋은 거래",
    ratingPoor = "빈약한 거래",
    schedule = "일정",
    showDetails = "세부 정보 표시",
    summaryBad = "매우 불리하므로 가능하면 피하십시오.",
    summaryExcellent = "훌륭한 재정 조건.",
    summaryFair = "공정한 조건, 협상을 고려하십시오.",
    summaryGood = "좋은 조건, 시장 표준.",
    summaryPoor = "나쁜 조건, 높은 비용 또는 금리.",
    totalPaid = "총 지불액",
    lockTaxRate = "세율 잠금",
    unlockTaxRate = "세율 잠금 해제",
    currencySymbol = "₩",
    currency = "통화",
    totalCreditAmount = "총 신용 금액",
    taxAmount = "세금/공제 금액",
    netAmountDisbursed = "순 지급 금액",
    years = "년",
    loanTermTotalMonths = "대출 기간 (개월)",
    monthlyInstallment = "월 할부금",
    principalInstallment = "원금 할부금",
    otherFees = "기타 수수료",
    insuranceCost = "보험료",
    aprc = "연간 비용 비율 (APRC)",
    totalAmountPayable = "총 지불 금액",
    prepaidFeeFixed = "처리 수수료 (고정 금액)",
    prepaidFeePercentage = "처리 수수료 (백분율)",
    months = "개월",
    description = "이 분석기는 대출 제안이 귀하에게 유리한지 평가하는 데 도움이 됩니다. 표준 계산기와 달리 이자율 입력이 필요하지 않습니다. 대신 지불 및 수수료를 기반으로 APR 및 총 신용 비용을 계산하여 거래 등급과 자세한 차트를 제공합니다.",
    agree = "동의",
    information = "정보",
    errorCalculationOverflow = "APR이 너무 높습니다. 계산 오버플로입니다.",
    errorTotalPaymentIsLessThanLoanAmount = "수령 금액이 대출 금액보다 적습니다.",
    errorDivisionByZero = "0으로 나누기",
    errorNegativeResult = "음수 결과",
    errorRateTooHigh = "요금이 너무 높습니다",
    errorCalculation = "올바른 데이터를 입력하십시오",
    close = "닫기",

    hi = "안녕하세요",
    guest = "게스트",
    account = "계정",
    signInWithGoogle = "Google로 로그인",
    signOut = "로그아웃",
    settings = "설정",
    about = "정보",
    privacyPolicy = "개인정보 처리방침",
    termsOfService = "서비스 약관",
    language = "언어",

    theme = "테마",
    light = "라이트",
    dark = "다크",
    system = "시스템",
    toggleExpand = "확장/축소",
)
